import { render, staticRenderFns } from "./OrdinePerFamiliare.vue?vue&type=template&id=50059808&"
import script from "./OrdinePerFamiliare.vue?vue&type=script&lang=js&"
export * from "./OrdinePerFamiliare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports